var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.049.64 7.77 10.965 0 19.359h1.749l6.803-7.35 5.497 7.35H20L11.844 8.454 19.077.64h-1.75l-6.265 6.769L6 .639zM2.62 1.928h2.734l12.073 16.143h-2.734z"
  })));
};
export default SvgTwitter;